import React from 'react';
import ReactDOM from 'react-dom';
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";
import Confirmation from './components/confirmation';
import InititalForm from './components/initial-form';

const WcOffline = () => {

    return (
        <Router>
            <Routes>
                <Route path="offline" element={<InititalForm />} />
                <Route path="offline/confirmation" element={<Confirmation />} />
            </Routes>
        </Router>
    )
}
ReactDOM.render(<WcOffline />, document.getElementById('wc-offline-react-wrap'));